<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-static-element-interactions -->
<div
    class="itsl-common-input-dropdown__button-overlay {overlayClass}"
    on:click={toggle}
>
</div>

<div class:itsl-common-input-dropdown__wrapper={labelPosition === 'left'}>
    {#if labelPosition === 'left'}
    <div
        id={buttonDescriptionId}
        class="itsl-common-input-dropdown__label itsl-common-input-dropdown__label--position-left {labelHidden ? 'hidden' : ''}">
        {labelText}
        {#if required}
        <span
            aria-hidden="true"
            class="itsl-common-input-dropdown__required-star"
        >*</span>
        {/if}
    </div>
    {/if}
    <div
        class="itsl-common-input-dropdown__container"
        class:itsl-common-input-dropdown__container--without-margin={labelHidden}
        class:itsl-common-input-dropdown__container--extend-right={extendButtonPosition === 'right'}
        class:itsl-common-input-dropdown__container--full-width={labelPosition === 'left'}>
        {#if extendable && extendButtonPosition === 'up'}
            <div class="itsl-common-input-dropdown__caption">
                {#if labelPosition === 'up'}
                <div>
                    <div
                        id={buttonDescriptionId}
                        class="itsl-common-input-dropdown__label {labelHidden ? 'hidden' : ''}">
                        {labelText}
                        {#if required}
                        <span
                            aria-hidden="true"
                            class="itsl-common-input-dropdown__required-star"
                        >*</span>
                        {/if}
                    </div>
                </div>
                {/if}
                <div>
                    <Button
                        id={`${id}-extend-button`}
                        type="plain"
                        text={extendButtonText}
                        {haspopup}
                        on:click={event => dispatch('extend', event)} />
                </div>
            </div>
        {:else if labelPosition === 'up'}
            <div
                id={buttonDescriptionId}
                class="itsl-common-input-dropdown__label {labelHidden ? 'hidden' : ''}">
                {labelText}
                {#if required}
                <span
                    aria-hidden="true"
                    class="itsl-common-input-dropdown__required-star"
                >*</span>
                {/if}
            </div>
        {/if}
        <div
            class="itsl-common-input-dropdown itsl-common-input-dropdown-{align}__{position}"
            {id}
        >
            <button
                id={`${id}-button`}
                type="button"
                class:itsl-common-input-dropdown__button={!isInvalid}
                class:itsl-common-input-dropdown__button--invalid={isInvalid}
                {disabled}
                aria-haspopup={true}
                aria-owns={dropdownContainerId}
                aria-describedby={buttonDescriptionId}
                on:click={toggle}
                on:keyup={keyUpHandler}
                on:keydown={keyDownHandler}
            >
                {text}
            </button>
            <div id={dropdownContainerId}>
                <Dropdown
                    {expanded}
                    {items}
                    {responsive}
                    id={`${id}-list`}
                    on:dropdownClose={closeHandler}
                    on:submenuClose={submenuHandler}
                    on:selectedOption={selectedOptionHandler}>
                    <div slot="header">
                        <slot name="header"></slot>
                    </div>
                    <div slot="footer">
                        <slot name="footer"></slot>
                    </div>
                </Dropdown>
            </div>
        </div>
        {#if extendable && extendButtonPosition === 'right'}
        <div>
            <Button
                id={`${id}-extend-button`}
                type="plain"
                text={extendButtonText}
                on:click={() => dispatch('extend')}/>
        </div>
        {/if}
    </div>
</div>

<script>
    import Button from '@itslearning/prometheus/assets/inputs/Button/v1/Button.svelte';
    import Dropdown from '@itslearning/prometheus/assets/dropdowns/Dropdown/v1/Dropdown.svelte';

    import { focusFirstItemIn, hideOpenSubmenus, removeFocusFromParentDropdown } from '@itslearning/prometheus/assets/dropdowns/Dropdown/v1/dropdownHelper.js';
    import { Keys } from '@itslearning/atlas/keyboard/keys.js';
    import { normalizeKey } from '@itslearning/atlas/keyboard/normalize.js';
    import { guidV4 } from '@itslearning/atlas/generate/guid.js';
    import { createEventDispatcher, tick } from 'svelte';
    import { DEFAULT_ITEM_VALUE } from '../utils/constants.js';

    const dispatch = createEventDispatcher();
    const buttonDescriptionId = `buttonDescription${guidV4()}`;
    const dropdownContainerId = `dropdownContainer${guidV4()}`;

    export let expanded = false;
    export let disabled = false;
    export let id = `extendableSelector${guidV4()}`;
    export let items = [];
    export let responsive = true;
    export let text = 'ChangeMe';
    export let position = 'down';
    export let labelText = 'Click me!';
    export let labelHidden = false;
    export let extendButtonText = '';
    export let extendable = true;
    export let selectedValue = DEFAULT_ITEM_VALUE;
    export let extendButtonPosition = 'up';
    export let required = false;
    export let haspopup = false;
    export let align = 'left'; // align dropdown from the 'left' or the 'right'
    export let labelPosition = 'up';

    $: overlayClass = responsive && expanded ? 'itsl-common-input-dropdown__button-overlay--visible' : '';
    $: isInvalid =  required && selectedValue === DEFAULT_ITEM_VALUE;

    function selectedOptionHandler(event) {
        for (const item of items) {
            const selectedOption = item.options.find(opt => opt.value === event.detail.data);

            if (selectedOption) {
                text = selectedOption.label;
                selectedValue = selectedOption.value;
                break;
            }
        }

        returnFocus();
        dispatch('selectedOption', event);
    }

    function closeHandler({ detail: event }) {
        const buttonElement = document.querySelector(`#${id}-button`);

        if (buttonElement.contains(event.target)) {
            return;
        }

        const { key } = event;

        expanded = false;

        switch (normalizeKey(key)) {
            case Keys.ESCAPE:
                returnFocus();
                break;
            default:
                return;
        }
    }

    function submenuHandler(event) {
        event.stopPropagation();
        hideOpenSubmenus();
    }

    async function keyDownHandler(event) {
        const { key } = event;

        switch (normalizeKey(key)) {
            case Keys.DOWN: {
                event.preventDefault();
                expanded = true;
                const dropdown = document.querySelector(`#${id}`);

                await tick();
                focusFirstItemIn(dropdown);
                break;
            }
            case Keys.TAB:
                hideOpenSubmenus();
                removeFocusFromParentDropdown();
                expanded = false;
                break;
            case Keys.ENTER:
            case Keys.SPACE:
                event.preventDefault();
                await toggle(event, true);
                break;
            default:
                return;
        }
    }

    function keyUpHandler(event) {
        const { key } = event;

        switch (normalizeKey(key)) {
            case Keys.ESCAPE:
                expanded = false;
                returnFocus();
                break;
        default:
            return;
        }
    }

    async function toggle(event, setFocus = false) {
        event.preventDefault();
        dispatch('beforeToggle', event);

        expanded = !expanded;

        if (items.length && setFocus) {
            const dropdown = document.querySelector(`#${id}`);

            await tick();
            focusFirstItemIn(dropdown);
        }
    }

    function returnFocus() {
        const buttonElement = document.querySelector(`#${id}-button`);
        buttonElement.focus();
    }
</script>
